import { Inject, Injectable } from '@angular/core';
import { createFeatureSelector, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ifObservable } from '../../ngrx-helpers/helpers';
import { State } from './ngrx/reducers';
import { GetTags, GetResources } from './ngrx/actions';
import { Tag, Resource } from '@bidi/common-services';
import flow from 'lodash/fp/flow';
import deburr from 'lodash/fp/deburr';
import lowerCase from 'lodash/fp/lowerCase';
import sortBy from 'lodash/fp/sortBy';

const tagsSort: any = sortBy(flow( (t: any) => t.name,  deburr, lowerCase ));

@Injectable()
export class ContentsLibraryServices {
    static featureName = '@bidi/common-components ContentsLibrary';

    constructor (
        @Inject('ENV') private environment,
        private store: Store<any>
      ) {

      }
    private state$: Observable<State> = this.store.pipe(select(createFeatureSelector(ContentsLibraryServices.featureName)));
    private resourcesList$: Observable<Resource[]> = this.state$.pipe(select('resources'));
    private districtTagsList$: Observable<Tag[]> = this.state$.pipe(select('tags', 'jurisdiccion'));
    private ejesTagsList$: Observable<Tag[]> = this.state$.pipe(select('tags', 'eje'));
    private asignaturesTagsList$: Observable<Tag[]> = this.state$.pipe(select('tags', 'materia'));
    private levelsTagsList$: Observable<Tag[]> = this.state$.pipe(
      select('tags', 'nivel')
    );



    preFilter(params) {
        console.log('params');
    }


    resList$: Observable<Resource[]> = ifObservable(
        this.resourcesList$,
        this.resourcesList$,
        of([]).pipe(tap(() => this.getResources()))
    );

    districtsTags$: Observable<Tag[]> = ifObservable(
        this.districtTagsList$,
        this.districtTagsList$,
        of([]).pipe(tap(() => this.getTags('jurisdiccion')))
    ).pipe(map(tagsSort));



    ejesTags$: Observable<Tag[]> = ifObservable(
        this.ejesTagsList$,
        this.ejesTagsList$,
        of([]).pipe(tap(() => this.getTags('eje')))
    ).pipe(map(tagsSort));;

    asignaturesTags$: Observable<Tag[]> = ifObservable(
        this.asignaturesTagsList$,
        this.asignaturesTagsList$,
        of([]).pipe(tap(() => this.getTags('materia')))
    ).pipe(map(tagsSort));;

    levelsTags$: Observable<Tag[]> = ifObservable(
        this.levelsTagsList$,
        this.levelsTagsList$,
        of([]).pipe(tap(() => this.getTags('nivel')))
    ).pipe(map(tagsSort));;

    private getTags(type){
        this.store.dispatch(new GetTags({type}));
    }

    getResources(config? : any){
        this.store.dispatch(new GetResources(config));
    }

}
